// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as DeleteComponent} from './Delete.svg';

import Icon, { TIconProps } from '../Icon';

export const IconDelete = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <DeleteComponent/>
  </Icon>
));
